import { QueryObserverOptions } from "@tanstack/react-query"

import { axiosPublic } from "./generic/AxiosInterceptor/AxiosInterceptor"
import { makeFileInstance } from "./generic/FileInstance"

// Sets defaults used in `buildApiFromServices`
export const queryOptions: Partial<QueryObserverOptions> = {
  staleTime: 24 * 60 * 60 * 1000, // 24 hours
  gcTime: 24 * 60 * 60 * 1000,
  refetchOnWindowFocus: false,
}

export const getLogo = (id: string, version?: string) =>
  axiosPublic({
    url: `/public/practice/${id}/logo${version ? `?v=${version}` : ""}`,
    method: "get",
    responseType: "blob",
    timeout: 5000,
    // A failed logo fetch is cosmetic: `PracticeLogo` falls back to the MijnPraktijk
    // mark and the practice name.
    suppressErrorToast: true,
  }).then(makeFileInstance)
